function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

/* eslint-disable */
// This icon has been generated. Do not edit it directly.
import React from 'react';
var IconPdfFile = /*#__PURE__*/
function (_React$PureComponent) {
  _inherits(IconPdfFile, _React$PureComponent);
  function IconPdfFile() {
    _classCallCheck(this, IconPdfFile);
    return _possibleConstructorReturn(this, _getPrototypeOf(IconPdfFile).apply(this, arguments));
  }
  _createClass(IconPdfFile, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        height = _this$props.height,
        color = _this$props.color,
        onClick = _this$props.onClick,
        size = _this$props.size,
        style = _this$props.style,
        width = _this$props.width,
        className = _this$props.className,
        rest = _objectWithoutProperties(_this$props, ["height", "color", "onClick", "size", "style", "width", "className"]);
      return React.createElement("svg", _extends({}, rest, {
        height: height || size,
        width: width || size,
        onClick: onClick,
        style: style,
        className: className,
        fill: color,
        viewBox: "0 0 512 512"
      }), React.createElement("path", {
        fillRule: "evenodd",
        d: "M483.74 414.332H161.893c-12.107 0-21.935-9.618-21.935-21.54V250.401c0-11.909 9.828-21.564 21.935-21.564H483.74c12.13 0 21.958 9.655 21.958 21.564v142.391c0 11.922-9.828 21.54-21.958 21.54zM267.317 293.921a26.726 26.726 0 0 0-5.949-9.945c-2.719-2.904-6.229-5.228-10.55-6.971-4.322-1.766-9.573-2.647-15.731-2.647h-44.428v96.734h21.657v-34.695h22.771c6.158 0 11.409-.881 15.731-2.646 4.322-1.744 7.832-4.091 10.55-6.972a26.808 26.808 0 0 0 5.949-9.876c1.229-3.717 1.834-7.553 1.834-11.524a36.63 36.63 0 0 0-1.834-11.458zm99.195 7.252c-2.254-5.949-5.389-10.921-9.387-14.896-3.998-3.974-8.737-6.947-14.219-8.946-5.461-1.999-11.389-2.974-17.707-2.974h-42.524v96.734h42.524c7.528 0 14.08-1.256 19.634-3.743 5.578-2.461 10.224-5.878 13.94-10.224 3.743-4.322 6.507-9.48 8.367-15.43 1.835-5.971 2.74-12.478 2.74-19.518.001-8.037-1.114-15.032-3.368-21.003zm87.695-26.816h-69.269v96.734h21.634v-39.968h41.269v-16.522h-41.269v-22.354h47.635v-17.89zm-113.579 72.404c-2.277 2.302-4.903 3.95-7.855 4.951a28.262 28.262 0 0 1-9.108 1.486h-19.332v-60.95h15.475c5.32 0 9.807.722 13.455 2.232 3.626 1.486 6.552 3.624 8.76 6.411 2.186 2.812 3.786 6.183 4.763 10.109.953 3.927 1.442 8.342 1.442 13.221 0 5.323-.698 9.831-2.068 13.523-1.375 3.721-3.232 6.718-5.532 9.017zm-98.22-29.534c-1.767 1.049-3.789 1.744-6.066 2.116a48.17 48.17 0 0 1-7.179.533h-16.847v-28.998h16.847c2.485 0 4.855.187 7.179.534 2.277.371 4.299 1.069 6.066 2.115 1.742 1.022 3.135 2.509 4.205 4.392 1.046 1.905 1.58 4.391 1.58 7.459 0 3.066-.534 5.554-1.58 7.458-1.07 1.882-2.464 3.348-4.205 4.391zm104.796-153.498l-.815-.836H248.24c-4.091 0-7.414-3.253-7.414-7.274V50.672l-1.859-1.975H54.471c-9.271 0-16.823 7.4-16.823 16.509v381.565c0 9.108 7.552 16.521 16.823 16.521h275.91c9.271 0 16.823-7.412 16.823-16.521v-22.167h31.345v22.167c0 26.094-21.609 47.311-48.168 47.311H54.471c-26.559 0-48.169-21.217-48.169-47.311V65.206c0-26.07 21.61-47.287 48.169-47.287h191.352c4.369 0 8.551 1.79 11.526 4.951l117.04 124.395c2.674 2.847 4.16 6.564 4.16 10.445v60.867h-31.345v-54.848zm-91.552-97.291v81.908h77.075l-77.075-81.908z",
        clipRule: "evenodd"
      }));
    }
  }]);
  return IconPdfFile;
}(React.PureComponent);
_defineProperty(IconPdfFile, "styleRoot", 'IconPdfFile');
_defineProperty(IconPdfFile, "defaultProps", {
  size: 32,
  color: '#333'
});
export { IconPdfFile as default };